module.exports = __webpack_public_path__ + "assets/InnerTangentDetailed.931e611bb41a2b0be27b30e684383858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/InnerTangentDetailed.png
// module id = 525
// module chunks = 0